var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationofaddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.318,
    height: 10.601,
    viewBox: "0 0 9.318 10.601",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33745",
    "data-name": "Group 33745",
    transform: "translate(-31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33738",
    "data-name": "Group 33738",
    transform: "translate(31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33737",
    "data-name": "Group 33737"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143134",
    "data-name": "Path 143134",
    d: "M33.889,7c-1.128-1.77-.986-1.549-1.019-1.6a3.391,3.391,0,0,1-.628-1.972,3.416,3.416,0,1,1,6.187,2l-1,1.57c1.07.164,2.889.654,2.889,1.733,0,.393-.257.954-1.48,1.391a9.8,9.8,0,0,1-3.179.473C33.422,10.6,31,9.97,31,8.738,31,7.659,32.817,7.169,33.889,7Zm4.022-1.912.011-.016a2.8,2.8,0,1,0-4.547-.031c.03.039-.126-.2,2.285,3.58ZM35.659,9.98c2.443,0,4.038-.718,4.038-1.242,0-.352-.819-.932-2.635-1.157l-1.141,1.79a.311.311,0,0,1-.524,0L34.256,7.58c-1.816.226-2.635.805-2.635,1.157C31.621,9.258,33.2,9.98,35.659,9.98Z",
    transform: "translate(-31)",
    fill: "#202035"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33740",
    "data-name": "Group 33740",
    transform: "translate(34.483 2.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33739",
    "data-name": "Group 33739",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143135",
    "data-name": "Path 143135",
    d: "M182.176,91A1.176,1.176,0,1,1,181,92.176,1.177,1.177,0,0,1,182.176,91Zm0,1.881a.705.705,0,1,0-.705-.705A.706.706,0,0,0,182.176,92.881Z",
    transform: "translate(-181 -91)",
    fill: "#202035"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationofaddress);
export default __webpack_public_path__ + "static/media/location of address.e17068178d8019c752aac4f86c3f1168.svg";
export { ForwardRef as ReactComponent };